import { useRouter } from 'next/router';
import React from 'react';

import ROUTES from '../../routes';

import Card from '@components/blog/Card';
import PageNavigation from '@components/blog/PageNavigation';
import CTA from '@components/CTA';
import CustomHead from '@components/CustomHead';
import Footer from '@components/FooterNew';
import Header from '@components/HeaderNew';
import Heading from '@components/Heading';
import { SectionContainer } from '@components/landing/sectionComponents';
import { revalidate } from '@utils/constants';
import { getBlogPosts } from '@utils/contentfulClient';

export const getStaticProps = async () => {
  try {
    const posts = await getBlogPosts();
    const newPages = [];
    let newCurrentPage = -1;
    posts.forEach((post, i) => {
      // Each page has 8 posts
      const toNextPage = i % 8 === 0;
      if (toNextPage) {
        newCurrentPage += 1;
        newPages.push({ posts: [post] });
      } else newPages[newCurrentPage].posts.push(post);
    });
    return {
      props: {
        pages: newPages,
      },
      revalidate,
    };
  } catch (error) {
    console.error(error);
    return {
      props: {
        pages: null,
        pageNum: null,
        err: 'Something went wrong 😕',
      },
    };
  }
};

const Blog = ({ pages }) => {
  const router = useRouter();
  const parsedPageNum = parseInt(
    typeof router.query.page === 'string' && router.query.page
      ? router.query.page
      : '1',
    10,
  );
  const pageNum = Number.isNaN(parsedPageNum) ? 1 : parsedPageNum - 1;
  const currentPage = pages?.[pageNum];

  return (
    <>
      <CustomHead
        meta={{
          title: 'Blog | PopSQL',
        }}
        openGraph={undefined}
      />
      <main>
        <Header />
        {/* @ts-expect-error fixme once SectionContainer is typed */}
        <SectionContainer styles={{ paddingBottom: '0', paddingTop: '84px' }}>
          <Heading size="lg" className="mb-4" Tag="h1">
            Blog
          </Heading>
          <p className="text-center gap-2 lg:gap-4 space-between flex font-medium text-gray-500 max-w-xl mx-auto leading-normal text-sm lg:text-lg font-inter mb-8 lg:mb-16">
            <span>
              <a className="hover:text-blue-200" href={ROUTES.changelog}>
                Read our changelog
              </a>{' '}
              to hear first
            </span>
            <span className="hidden md:inline">⏤</span>
            <a
              className="hidden md:inline hover:text-blue-200"
              href="https://twitter.com/popsql"
            >
              Follow us on Twitter
            </a>
          </p>

          {currentPage && (
            <div
              className={`grid grid-cols-1 lg:grid-cols-2 mx-auto gap-16 my-12 max-w-6xl`}
            >
              {currentPage.posts.map((post) => (
                <Card
                  key={`post-${post.fields.slug}`}
                  post={post.fields}
                  href={ROUTES.blogPost().href}
                  asPath={ROUTES.blogPost(post.fields.slug).asPath}
                />
              ))}
            </div>
          )}
          {/* @ts-expect-error fixme when PageNavigation is typed */}
          <PageNavigation pages={pages} currentPage={pageNum} pathname="blog" />
        </SectionContainer>
        {/* @ts-expect-error fixme when CTA is typed */}
        <CTA />
      </main>
      <Footer />
    </>
  );
};

export default Blog;
